<!--
  author：Zoufx
  description：用户
  date：2020/9/3
-->
<template>
  <el-container>
    <el-drawer title="用户" :visible="formVisible" :before-close="handleClose" append-to-body :wrapperClosable="false"
               @open="handleOpen">
      <div style="height: calc(100% - 67px);">
        <el-scrollbar class="drawer_scrollbar">
          <el-row style="padding: 30px">
            <el-form ref="form" :model="form" :rules="rules" label-width="90px">
              <el-form-item label="用户名" prop="loginName">
                <el-input v-model="form.loginName" placeholder="请输入用户名" size="medium"
                          :disabled="submitUrl !== '/sysUser/save'"/>
              </el-form-item>
              <el-form-item label="昵称" prop="nickName">
                <el-input v-model="form.nickName" placeholder="请输入昵称" size="medium"/>
              </el-form-item>
              <el-form-item label="真实姓名" prop="realName">
                <el-input v-model="form.realName" placeholder="请输入真实姓名" size="medium"/>
              </el-form-item>
              <el-form-item label="电话" prop="userTel">
                <el-input v-model="form.userTel" placeholder="请输入电话" size="medium"/>
              </el-form-item>
              <el-form-item label="角色" prop="roleId">
                <el-select v-model="form.roleId" placeholder="请选择角色" style="width: 100%" size="medium">
                  <el-option v-for="userRole in roleData" :key="userRole.id" :label="userRole.roleName"
                             :value="userRole.id"/>
                </el-select>
              </el-form-item>
              <el-form-item label="部门">
                <el-cascader placeholder="请选择部门"
                             :options="deptData"
                             :props="{ checkStrictly: true }"
                             filterable
                             clearable
                             v-model="form.deptIds"
                             style="width: 100%"></el-cascader>

              </el-form-item>
              <el-form-item label="备注">
                <el-input type="textarea" rows="3" v-model="form.remarks" placeholder="请输入备注"/>
              </el-form-item>
            </el-form>
          </el-row>
        </el-scrollbar>
      </div>
      <el-row class="drawer_footer">
        <el-button type="primary" @click="submit" :disabled="$store.state.loading" size="medium">确 定</el-button>
        <el-button @click="handleClose" :disabled="$store.state.loading" size="medium">取 消</el-button>
      </el-row>
    </el-drawer>
  </el-container>
</template>

<script>

  export default {
    name: "SysUserForm",
    props: ['formVisible', 'selRow', 'submitUrl','roleData','deptData'],
    data() {
      const checkLoginNameExist = async (rule, value, callback) => {
        let uPattern = /^[a-zA-Z0-9_-]{4,16}$/;
        if (!value) {
          return callback(new Error('请输入用户名'));
        } else if (uPattern.test(value)) {
          return callback()
        } else {
          return callback('用户名只能是4到16位(字母，数字，下划线，减号)')
        }
        let params = {loginName: value};
        if (this.form.id) params.id = this.form.id;
        let {obj} = await this.postRequest('/sysUser/checkLoginNameExist', params);
        return obj ? callback() : callback(new Error('用户名已存在'))
      };
      const realName = async (rule, value, callback) => {
        let reg = /^[\u4E00-\u9FA5A-Za-z\s]+(·[\u4E00-\u9FA5A-Za-z]+)*$/;
        if (!value) {
          return callback(new Error('请输入真实姓名'));
        } else if (reg.test(value)) {
          return callback()
        } else {
          return callback('真实姓名只能是中文英文')
        }
      };
      return {
        form: {},
        rules: {
          loginName: [
            {required: true,validator: checkLoginNameExist, trigger: 'change'}
          ],
          realName: [
            {required: true,validator: realName, trigger: 'change'}
          ],
          userSex: [
            {required: true, message: '请选择性别', trigger: 'change'}
          ],
          roleId: [
            {required: true, message: '请选择角色', trigger: 'change'}
          ],
          orderNo: [
            {type: 'number', message: '请输入数字', trigger: 'blur'}
          ]
        }
      }
    }
    ,methods:{
      async submit() {
        let valid = await this.$refs.form.validate().catch(() => {});
        if (!valid) return;
        let param = this.form;
        let deptIds = param.deptIds;
        if(Array.isArray(deptIds)){
          param.deptIds = deptIds[deptIds.length - 1];
        }else{
          let _deptIds = [];
          _deptIds.push(deptIds);
          param.deptIds = _deptIds;
        }
        this.form.deptList = [];
        await this.postRequest(this.submitUrl, param);
        this.handleClose();
        this.$emit('refreshList')
      },
      handleOpen() {
        this.form = {...this.selRow};
        let deptIds = [];
        if(this.form.deptList){
          this.form.deptList.forEach((dept)=>{
            deptIds.push(dept.id);
          });
        }
        if(deptIds.length > 0){
          this.form.deptIds= deptIds[0];
        }
      },
      handleClose() {
        this.$refs.form.clearValidate();
        this.$emit('update:formVisible', false)
      }
    }
  }
</script>

<style scoped>

</style>
